export default __webpack_public_path__ + "static/hero-8bb2473d88a672cdef6f8ea09b7de488.svg";